var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGh = function SvgGh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M0 12c0 1.467.264 2.873.746 4.173L12 16.695l11.254-.522c.482-1.3.746-2.706.746-4.174 0-1.468-.264-2.874-.746-4.174L12 7.303.746 7.825A11.975 11.975 0 0 0 0 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12-.001C6.84-.001 2.442 3.256.746 7.825h22.507C21.558 3.255 17.16 0 12 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M23.253 16.174H.746C2.442 20.744 6.84 24 12 24c5.16 0 9.558-3.256 11.253-7.826Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m12 7.826 1.036 3.189h3.353l-2.713 1.97 1.036 3.19L12 14.202l-2.712 1.971 1.036-3.188-2.713-1.971h3.353L12 7.826Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGh;